import classNames from "classnames";
import { OverlayPanel } from "primereact/overlaypanel";
import * as React from "react";
import { Button } from "reactstrap";
import { Publication } from "../../../api/openapi-generator";
import { useRef } from "react";

interface Props {
  publications: string[],
  allPublications: Record<string, Publication>,
  buttonStyle?: React.CSSProperties,
  small?: boolean,
}

function PublicationButton(props: Props) {
  const ref = useRef<OverlayPanel>(null);

  if (props.publications === null || props.publications.length === 0) {
    return null;
  }
  return <>
    <Button
      size="sm"
      onClick={(e) => ref.current?.toggle(e, e.target)}
      className={classNames("ll-publication-button", {"ll-publication-button-small": props.small === true})}
      style={props.buttonStyle}
    >
      {props.publications.length} {props.publications.length == 1 ? "Publication" : "Publications"} ▼
    </Button>
    <OverlayPanel ref={ref} showCloseIcon className="ll-publications-overlay">
      {props.publications
        .map(pubmed => props.allPublications[pubmed])
        .filter(pubmed => pubmed !== undefined)
        .map(p => (
          <div key={p.pubmed} className="ll-publication">
            <p><strong>"{p.title}"</strong></p>
            <p>{p.authors.join(', ')}</p>
            <p>{p.journal} [<a href={`https://pubmed.ncbi.nlm.nih.gov/${p.pubmed}`} target="_blank">PubMed</a>]</p>
          </div>
        ))
      }
    </OverlayPanel>
  </>
}

export default PublicationButton;
